<template>
  <main>
    <div style="background-color: white">
      <div class="about">
        <gradientAnimation />
        <div class="content">
          <h1>{{ $t('about.heroTitle') }}</h1>
          <h2 v-html="$t('about.heroBody')"></h2>
        </div>
      </div>
      <div class="introduction diagonal">
        <div class="content">
          <h3>{{ $t('about.introTitle') }}</h3>
          <ul>
            <li v-for="(item, index) in introItems" :key="index" v-html="item"></li>
          </ul>
        </div>
      </div>

      <div class="cover">
        <div class="content">
          <h3>{{ $t('about.coverTitle') }}</h3>
          <p>{{ $t('about.coverBody') }}</p>
          <ul>
            <li v-for="(item,index) in regions" :key="index">
              <img :src="require('@/assets/images/Region/region-'+(index+1)+'.png')">
              <span>{{item}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import gradientAnimation from '@/components/GradientAnimation'

  export default {
    name: 'Home',
    data() {
      return {
        height: window.innerHeight,
        serviceGranim: undefined,
      };
    },
    components: {
      gradientAnimation,
    },
    computed: {
      introItems() {
        return this.$t('about.introItems');
      },
      regions() {
        return this.$t('about.regions');
      },
    },
    mounted() {
      if (window.innerWidth < 1000) this.height = 0;
      window.addEventListener('resize', () => {
        if (window.innerWidth >= 1000) this.height = window.innerHeight;
      });
    },
  };
</script>

<style lang="less" scoped>
  .about {
    position: relative;

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 747px;
      padding-bottom: 40px;

      & > h1 {
        margin-bottom: 20px;
        color: white;
        font-size: 60px;
        font-weight: bold;
        line-height: 70px;
        text-align: center;
      }

      & > h2 {
        margin-bottom: 30px;
        color: white;
        font-size: 20px;
        font-weight: 200;
        line-height: 36px;
        text-align: center;
      }
    }
  }

  .introduction {
    margin-top: -60px;
    padding: 137px 0;

    &:before {
      background-color: white;
    }

    .content {

      & > h3 {
        margin-bottom: 10px;
        color: #082440;
        font-size: 36px;
        font-weight: 400;
        line-height: 54px;
      }

      & > ul {
        display: flex;

        & > li {
          position: relative;
          width: 50%;
          color: #092641;
          font-size: 20px;
          font-weight: 200;
          line-height: 36px;

          &:first-child {
            margin-right: 90px;
          }

          & > span {
            font-weight: 400;
            color: var(--spanColor1);
          }

          &:before {
            position: absolute;
            top: 9px;
            left: -15px;
            width: 1px;
            height: 19px;
            content: '';
            background: #0070FF;
          }
        }
      }

      .oneStop {
        margin-top: 30px;
      }
    }
  }

  .cover {
    background: #F6F9FC;
    &:before {
      width: 100%;
      height: 100%;
      content: '';
      background: #F6F9FC;
      position: absolute;
    }
    .content {
      padding: 85px 0;
      & > h3 {
        font-size: 36px;
        font-weight: 400;
        color: #082440;
        line-height: 54px;
      }
      & > p {
        font-size: 20px;
        font-weight: 400;
        color: #092641;
        line-height: 36px;
        margin-bottom: 30px;
      }
      & > ul {
        display: flex;
        flex-wrap: wrap;
        & > li {
          display: flex;
          align-items: center;
          width: calc(20% - 16px);
          padding: 13px 24px;
          background: #FFFFFF;
          border-radius: 8px;
          border: 1px solid #DEDFEF;
          margin-right: 64px;
          margin-bottom: 20px;
          & > img {
            width: 31px;
            margin-right: 16px;
          }
          & > span {
            font-size: 14px;
            font-weight: 400;
            color: #525F7F;
            line-height: 20px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1000px) {
    .service {
      .bg1 {
        width: 189px;
      }

      .bg2 {
        width: 165px;
      }

      & > ul {
        bottom: 10px;

        & > li {
          margin: 0 5px;
          font-size: 12px;
        }
      }

      .content {
        flex-direction: column;
        justify-content: center;
        min-height: auto;
        padding: 50px 20px 70px;

        & > div:first-child {
          width: auto;
          display: flex;
          flex-direction: column;
          align-items: center;

          & > h1 {
            font-size: 32px;
            margin-bottom: 20px;
            text-align: center;
          }

          & > p {
            margin-bottom: 32px;
            font-size: 18px;
            line-height: 28px;
            text-align: center;
          }

          & > a {
            position: relative;
            width: 200px;
            height: 40px;
            font-size: 14px;
            line-height: 40px;
            border-radius: 20px;
            z-index: 1;
          }
        }

        & > div:last-child {
          margin: -220px 0;
        }
      }
    }

    .choice {
      padding: 32px 20px;

      & > h1 {
        margin-bottom: 32px;
      }

      & > ul {
        height: auto;
        flex-direction: column;

        & > li {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: calc(100% - 30px);
          height: 125px;
          padding: 0 0 0 60px;
          border-right: none;
          border-bottom: 1px solid #E5E5E5;

          &:last-child {
            border-bottom: none;
          }

          & > i {
            position: absolute;
            top: 20px;
            left: 0;
          }

          & > h3 {
            font-size: 18px;
            margin-bottom: 5px;
          }

          & > span {
            line-height: 24px;
          }
        }
      }
    }

    .account {
      .content {
        padding: 32px 20px;

        .desc {
          margin-bottom: 0;
          padding: 20px 15px;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;

          & > div {
            width: auto;

            & > h1 {
              margin-bottom: 10px;
              font-size: 28px;
            }

            & > span {
              display: inline-block;
              margin-bottom: 20px;
              font-size: 18px;
              line-height: 28px;
            }
          }

          & > a {
            height: 32px;
            font-size: 14px;
            line-height: 32px;
            border-radius: 16px;
          }
        }

        .list {
          flex-direction: column;

          & > img {
            width: 100%;
            margin-left: 0;
            margin-bottom: -15px;
          }

          & > ul {
            flex-direction: column;
            margin-bottom: 0;

            & > li {
              width: 100%;
              margin-left: 0;
              margin-bottom: 20px;

              & > h3 {
                margin-bottom: 8px;
                font-size: 18px;
              }

              & > span {
                color: #72747D;
                line-height: 24px;
              }
            }
          }
        }
      }
    }

    .global {
      .bg1 {
        width: 228px;
      }

      .bg2 {
        width: 200px;
      }

      .content {
        padding: 40px 20px;

        & > h1 {
          margin-bottom: 36px;
        }

        .number {
          flex-wrap: wrap;
          justify-content: space-around;
          margin-bottom: 30px;

          & > li {
            width: 33.33333%;
            margin-bottom: 20px;
          }
        }

        .region {
          & > li {
            width: calc(50% - 8px);
            height: 34px;
            margin-bottom: 15px;
            padding-left: 10px;

            & > img {
              margin-right: 10px;
            }

            &:nth-child(n+5):nth-child(-n+10) {
              display: none;
            }

            &:empty {
              background: linear-gradient(180deg,#52597B 0%,#3B4368 100%);
              box-shadow: none;
            }
          }
        }

        & > a {
          width: 200px;
          height: 40px;
          margin: 0 auto 50px;
          line-height: 40px;
          border-radius: 20px;
        }

        & > h3 {
          width: auto;
          font-size: 18px;
          line-height: 28px;
        }
      }
    }

    /* 即将推出 */
    .coming {
      margin-bottom: 10px;
    }

    .card {
      position: relative;

      .bg1 {
        width: 230px;
      }

      .bg2 {
        width: 200px;
      }

      .content {
        flex-direction: column;
        justify-content: center;
        padding: 50px 20px;

        & > div {
          width: auto;

          & > h1 {
            margin-bottom: 10px;
          }

          & > p {
            margin-bottom: 26px;
            font-size: 18px;
          }

          & > ul {
            display: flex;
            justify-content: space-between;
            margin-bottom: 24px;

            & > li {
              width: calc(50% - 18px);

              & > h3 {
                margin-bottom: 8px;
                font-size: 18px;
              }

              & > span {
                font-size: 18px;
                line-height: 28px;
              }
            }
          }

          & > a {
            width: 200px;
            height: 40px;
            margin-bottom: 26px;
            line-height: 40px;
            border-radius: 20px;
          }
        }

        & > img {
          width: 100%;
        }
      }
    }

    .business {
      .content {
        flex-direction: column;
        justify-content: center;
        padding: 40px 20px;

        & > img {
          width: 100%;
          margin-bottom: 32px;
        }

        & > div {
          width: auto;

          & > h1 {
            margin-bottom: 10px;
          }

          & > p {
            font-size: 18px;
            line-height: 28px;
          }
        }
      }
    }

    .risk {
      .content {
        padding: 40px 20px;

        & > h1 {
          margin-bottom: 10px;
        }

        & > p {
          margin-bottom: 30px;
          font-size: 18px;
        }

        & > ul {
          flex-direction: column;
          padding: 20px 15px;

          & > li {
            width: 100%;
            height: auto;
            margin-bottom: 16px;
            padding: 0;
            border-right: none;

            &:last-child {
              margin-bottom: 0;
            }

            & > h3 {
              margin-bottom: 5px;

              & > span {
                display: inline;
              }

              & > br {
                display: none;
              }
            }

            & > span {
              line-height: 24px;
            }
          }
        }
      }
    }

    .partner {
      padding: 40px 0;
      & > h2 {
        margin-bottom: 30px;
      }
      & > ul {
        flex-wrap: wrap;
        justify-content: center;
        & > li {
          width: calc(33% - 8px);
          height: 43px;
          margin-bottom: 10px;
          & > img {
            max-width: 98px;
          }
        }
      }
    }

    .case {
      background: #3B4368;
      .content {
        padding: 60px 0;
        & > h1 {
          color: white;
          text-align: center;
          margin-bottom: 43px;
        }

        .showCase {
          height: 446px;
          & > li {
            display: flex;
            flex-direction: column;
            & > img {
              position: static;
              height: 261px;
            }
            & > div {
              position: static;
              padding: 20px 15px;
              width: 290px;
              & > p {
                &:nth-child(1) {
                  font-size: 18px;
                  margin-bottom: 23px;
                }
              }
            }
          }
        }

        .pages {
          margin-top: 40px;
        }
      }
    }

    .step {
      padding: 40px 20px 50px;

      & > h1 {
        margin-bottom: 26px;
      }

      & > ul {
        width: auto;

        & > li {
          height: 96px;
          margin-bottom: 15px;
          padding: 15px;
        }
      }
    }
  }

  @media screen and (max-width: 1000px) {
    .about .content {
      height: auto;
      min-height: auto;
      padding: 110px 20px 40px;

      & > h1 {
        font-size: 34px;
        line-height: 1.18;
      }

      & > h2 {
        font-size: 18px;
        line-height: 30px;
      }
    }

    .introduction {
      margin-top: 0;
      padding: 72px 20px;

      .content > h3 {
        font-size: 30px;
        line-height: 40px;
      }

      .content > ul {
        flex-direction: column;

        & > li {
          width: 100%;
          font-size: 18px;
          line-height: 30px;

          &:first-child {
            margin-right: 0;
            margin-bottom: 24px;
          }
        }
      }
    }

    .cover .content {
      padding: 72px 20px;

      & > h3 {
        font-size: 30px;
        line-height: 40px;
      }

      & > p {
        font-size: 18px;
        line-height: 30px;
      }

      & > ul {
        gap: 16px;

        & > li {
          width: calc(50% - 8px);
          margin-right: 0;
          margin-bottom: 0;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .about .content {
      padding: 100px 16px 28px;

      & > h1 {
        font-size: 24px;
        line-height: 1.25;
      }

      & > h2 {
        margin-bottom: 0;
        font-size: 15px;
        line-height: 1.75;
        text-align: left;
      }
    }

    .introduction {
      padding: 64px 16px;

      .content {
        & > h3 {
          margin-bottom: 12px;
          font-size: 24px;
          line-height: 1.3;
        }

        & > ul {
          flex-direction: column;

          & > li {
            width: 100%;
            font-size: 15px;
            line-height: 1.6;

            &:first-child {
              margin-right: 0;
              margin-bottom: 20px;
            }
          }
        }
      }
    }

    .cover .content {
      padding: 64px 16px 72px;

      & > h3 {
        margin-bottom: 12px;
        font-size: 24px;
        line-height: 1.3;
      }

      & > p {
        margin-bottom: 20px;
        font-size: 15px;
        line-height: 1.6;
      }

      & > ul {
        display: flex;
        flex-direction: column;
        gap: 12px;

        & > li {
          width: 100%;
          margin-right: 0;
          margin-bottom: 0;
          padding: 12px 16px;

          & > img {
            width: 28px;
            margin-right: 12px;
          }

          & > span {
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }
  }
</style>
